// extracted by mini-css-extract-plugin
export default {"modalHeader":"vaa-z","modalContent":"waa-z","formWrapper":"xaa-z","fade":"yaa-z","fade-in":"zaa-z"};